var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","px-3":"","pt-3":""}},[_c('certificate-instructions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }